/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { GlobalProtectedRoute } from 'framework/authorization';
import { READ_BUDGETS_LIST, CREATE_BUDGET, UPDATE_BUDGET, READ_BUDGET } from 'domain/shared/budget';
import BudgetList from 'domain/finance/budget/List';
import { CreateBudget, UpdateBudget } from 'domain/finance/budget/createupdate';
import ViewBudget from 'domain/finance/budget/Show';
import { createRoute, Route } from 'framework/routing';
import { ProtectedRouter } from 'infrastructure/routing';
import BudgetContext from 'domain/finance/budget/BudgetContext';
import { BUDGET_PATH } from 'domain/shared/budget';

const useBudgetRoute = () => {
  const routers = createRoute({ listRoute: BUDGET_PATH });

  return {
    ...routers,
    copyEntityRoute: `${routers.singleEntityRoute}/copy`,
  };
};

const BudgetRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const {
    listRoute,
    singleEntityRoute,
    createRoute: createEntityRoute,
    updateRoute,
    copyEntityRoute,
  } = useBudgetRoute();

  return (
    <ProtectedRouter basePath={BUDGET_PATH}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_BUDGETS_LIST}>
              <BudgetList />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={createEntityRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={CREATE_BUDGET}>
              <CreateBudget />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={copyEntityRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={CREATE_BUDGET}>
              <CreateBudget />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={singleEntityRoute}
          element={
            <BudgetContext permissionToCheck={READ_BUDGET}>
              <ViewBudget />
            </BudgetContext>
          }
        />

        <Route
          path={updateRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={UPDATE_BUDGET}>
              <UpdateBudget />
            </GlobalProtectedRoute>
          }
        />

        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

BudgetRouter.getRouterPath = () => `${BUDGET_PATH}/*`;

export default BudgetRouter;
